import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class BodyStylingService {
  private _noOverflow = false;

  public get noOverflow(): boolean {
    return this._noOverflow;
  }

  public set noOverflow(value: boolean) {
    this._noOverflow = value;
  }

  private _signIn = false;

  public get signIn(): boolean {
    return this._signIn;
  }

  public set signIn(value: boolean) {
    this._signIn = value;
  }
}
